import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getUserTypeEditRole } from 'modules/settings/api';

export const useQueryUserTypeEditRole = ({ roleId }: { roleId: number }) => {
  const { data, isLoading, isError, isRefetching } = useQuery(
    QUERY_KEYS.SETTINGS_PROFILE_USER_TYPE_EDIT_ROLE,
    () => getUserTypeEditRole(roleId),
    {
      enabled: !!roleId,
      cacheTime: 0,
    },
  );

  return {
    userTypeEditRoleData: data,
    userTypeEditRoleLoading: isLoading,
    userTypeEditRoleError: isError,
    isRefetching,
  };
};
